import React from "react";
import EditInventory from "../../../Features/Forms/Inventory/Edit";

const Edit = () => {
  return (
    <div>
      <EditInventory />
    </div>
  );
};

export default Edit;
